import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE } from '../../config/api';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import './AdminBlogs.css';

const AdminBlogs = () => {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(null);

  const getAuthHeaders = () => {
    const token = localStorage.getItem('adminToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  useEffect(() => {
    loadPosts();
  }, []);

  const loadPosts = () => {
    axios
      .get(`${API_BASE}/api/admin/blog`, { headers: getAuthHeaders() })
      .then((res) => setPosts(res.data.posts || []))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  };

  const handleDelete = (id, title) => {
    if (!window.confirm(`حذف المنشور "${title}"؟`)) return;
    setDeleting(id);
    axios
      .delete(`${API_BASE}/api/admin/blog/${id}`, { headers: getAuthHeaders() })
      .then(() => {
        setPosts((prev) => prev.filter((p) => p.id !== id));
      })
      .catch((err) => alert(err.response?.data?.error || 'فشل الحذف'))
      .finally(() => setDeleting(null));
  };

  const formatDate = (d) => (d ? new Date(d).toLocaleDateString('ar-EG', { year: 'numeric', month: 'short', day: 'numeric' }) : '-');

  if (loading) return <div className="admin-loading">جاري التحميل...</div>;

  return (
    <div className="admin-blogs">
      <div className="admin-blogs-header">
        <h1 className="admin-page-title">منشورات المدونة</h1>
        <Link to="/admin/blog/new" className="admin-btn-primary">
          <FaPlus /> منشور جديد
        </Link>
      </div>
      {posts.length === 0 ? (
        <div className="admin-empty">
          لا توجد منشورات. <Link to="/admin/blog/new">إنشاء منشور</Link>
        </div>
      ) : (
        <div className="admin-blogs-table-wrap">
          <table className="admin-blogs-table">
            <thead>
              <tr>
                <th>العنوان</th>
                <th>الحالة</th>
                <th>التاريخ</th>
                <th>إجراءات</th>
              </tr>
            </thead>
            <tbody>
              {posts.map((post) => (
                <tr key={post.id}>
                  <td className="title-cell">{post.title}</td>
                  <td>
                    <span className={`status-badge status-${post.status}`}>
                      {post.status === 'published' ? 'منشور' : 'مسودة'}
                    </span>
                  </td>
                  <td>{formatDate(post.updated_at)}</td>
                  <td className="actions-cell">
                    <button
                      type="button"
                      className="admin-btn-icon"
                      onClick={() => navigate(`/admin/blog/${post.id}`)}
                      title="تعديل"
                    >
                      <FaEdit />
                    </button>
                    <button
                      type="button"
                      className="admin-btn-icon danger"
                      onClick={() => handleDelete(post.id, post.title)}
                      disabled={deleting === post.id}
                      title="حذف"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminBlogs;
